var map = {
	"./yelp-0.png": 1830,
	"./yelp-1.5.png": 1831,
	"./yelp-1.png": 1832,
	"./yelp-2.5.png": 1833,
	"./yelp-2.png": 1834,
	"./yelp-3.5.png": 1835,
	"./yelp-3.png": 1836,
	"./yelp-4.5.png": 1837,
	"./yelp-4.png": 1838,
	"./yelp-5.png": 1839
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 817;



//////////////////
// WEBPACK FOOTER
// ./assets/images/yelp-ratings ^\.\/yelp\-.*\.png$
// module id = 817
// module chunks = 0